import {
  useEffect,
  useState,
  type HTMLAttributes,
  type ReactNode,
} from "react";
import { cn } from "../cn";

export type LinkNavbar = {
  readonly href: string;
  readonly rotulo: string;
  readonly atual?: boolean;
};

export type PropsRkNavbar = HTMLAttributes<HTMLElement> & {
  readonly marca: ReactNode;
  readonly links?: readonly LinkNavbar[];
  readonly acoes?: ReactNode;
};

export function Navbar({
  marca,
  links = [],
  acoes,
  className,
  ...resto
}: PropsRkNavbar) {
  const [scrolled, definirScrolled] = useState(false);

  useEffect(() => {
    function aoScroll() {
      definirScrolled(window.scrollY > 8);
    }
    aoScroll();
    window.addEventListener("scroll", aoScroll, { passive: true });
    return () => window.removeEventListener("scroll", aoScroll);
  }, []);

  return (
    <header
      {...resto}
      className={cn("rk-navbar", scrolled && "rk-navbar--scrolled", className)}
    >
      <div className="rk-navbar__inner">
        <div className="rk-navbar__brand">{marca}</div>
        {links.length > 0 ? (
          <nav aria-label="Principal">
            <ul className="rk-navbar__links">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="rk-navbar__link rk-focusable"
                    aria-current={link.atual ? "page" : undefined}
                  >
                    {link.rotulo}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
        {acoes ? <div className="rk-navbar__actions">{acoes}</div> : null}
      </div>
    </header>
  );
}
